"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactor = void 0;
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../state");
var _GoogleForm = require("./GoogleForm");
var _EmailForm = require("./EmailForm");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TwoFactor = function TwoFactor(props) {
  var _useTwoFactor = (0, _state.useTwoFactor)(),
    kind = _useTwoFactor.kind,
    resendLoading = _useTwoFactor.resendLoading,
    resendRemainingTime = _useTwoFactor.resendRemainingTime,
    resend = _useTwoFactor.resend;
  return kind === 'google' ? /*#__PURE__*/_react.default.createElement(_GoogleForm.GoogleForm, {
    onSubmit: props.onGoogleFormSubmit,
    submitLoading: props.submitLoading
  }) : /*#__PURE__*/_react.default.createElement(_EmailForm.EmailForm, {
    onSubmit: props.onEmailFormSubmit,
    submitLoading: props.submitLoading,
    resendTwoFactor: function resendTwoFactor() {
      return resend(props.email);
    },
    resendTwoFactorLoading: resendLoading,
    resendTwoFactorRemainingTime: resendRemainingTime,
    contactSupportLink: ''
  });
};
exports.TwoFactor = TwoFactor;